import { filterDOMProps } from 'uniforms';
filterDOMProps.register('minCount', 'maxCount');
